module.exports = __webpack_public_path__ + "static/francois_deleau-50457f4a364334f046966ed73111db98.png";